import { Component } from '@angular/core';

@Component({
  selector: 'app-available-slots-dialog-content',
  templateUrl: './available-slots-dialog-content.component.html',
  styleUrl: './available-slots-dialog-content.component.scss',
})
export class AvailableSlotsDialogContentComponent {}
